import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import useCrmObjectTypeListingFilterState from 'framework-listing-lib/internal/hooks/useCrmObjectTypeListingFilterState';
import { createZustandStoreContext } from 'framework-listing-lib/internal/store/zustand';
import { createExpandableObjectIdsStore } from '../store/expandableObjectIdsStore';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmObjectTypeListingContext = /*#__PURE__*/createContext(null);
const FilterContext = /*#__PURE__*/createContext(null);
const {
  ContextProvider: FilterStateStoreContext,
  useStore: useFiltersStateStore
} = createZustandStoreContext();
const {
  ContextProvider: ExpandableObjectIdsContext,
  useStore: useExpandableObjectIdsStore
} = createZustandStoreContext();
export default function CrmObjectTypeListingClientProvider(t0) {
  "use memo";

  const $ = _c(37);
  const {
    associationSpecs,
    calendarProps,
    children,
    emptyStateFilter,
    fetcher,
    fetcherKey,
    folderProps,
    hiddenFilter: hiddenFilterProp,
    initialFilter,
    inlineEditProps,
    quickFilterProps,
    searchInputProps
  } = t0;
  const [uncontrolledFolderId, setUncontrolledFolderId] = useState(undefined);
  let t1;
  if ($[0] !== folderProps || $[1] !== uncontrolledFolderId) {
    t1 = folderProps !== null && folderProps !== void 0 && folderProps.onSetCurrentFolderId ? {
      onSetCurrentFolderId: folderProps.onSetCurrentFolderId,
      currentFolderId: folderProps.currentFolderId
    } : {
      onSetCurrentFolderId: setUncontrolledFolderId,
      currentFolderId: uncontrolledFolderId
    };
    $[0] = folderProps;
    $[1] = uncontrolledFolderId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    onSetCurrentFolderId,
    currentFolderId
  } = t1;
  let t2;
  if ($[3] !== calendarProps || $[4] !== currentFolderId || $[5] !== hiddenFilterProp || $[6] !== initialFilter) {
    t2 = {
      calendarProps,
      hiddenFilter: hiddenFilterProp,
      initialFilter,
      folderId: currentFolderId
    };
    $[3] = calendarProps;
    $[4] = currentFolderId;
    $[5] = hiddenFilterProp;
    $[6] = initialFilter;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    hiddenFilter,
    isFilterFromCustomView,
    filtersStateStore,
    filterGroups,
    quickFilters
  } = useCrmObjectTypeListingFilterState(t2);
  let t3;
  if ($[8] !== associationSpecs || $[9] !== calendarProps || $[10] !== currentFolderId || $[11] !== emptyStateFilter || $[12] !== fetcher || $[13] !== fetcherKey || $[14] !== folderProps || $[15] !== hiddenFilter || $[16] !== initialFilter || $[17] !== inlineEditProps || $[18] !== isFilterFromCustomView || $[19] !== onSetCurrentFolderId || $[20] !== quickFilterProps || $[21] !== searchInputProps) {
    t3 = {
      associationSpecs,
      calendarProps,
      emptyStateFilter,
      fetcher,
      fetcherKey,
      folderId: currentFolderId,
      folderProps,
      hiddenFilter,
      initialFilter,
      inlineEditProps,
      isFilterFromCustomView,
      onSetFolderId: onSetCurrentFolderId,
      quickFilterProps,
      searchInputProps
    };
    $[8] = associationSpecs;
    $[9] = calendarProps;
    $[10] = currentFolderId;
    $[11] = emptyStateFilter;
    $[12] = fetcher;
    $[13] = fetcherKey;
    $[14] = folderProps;
    $[15] = hiddenFilter;
    $[16] = initialFilter;
    $[17] = inlineEditProps;
    $[18] = isFilterFromCustomView;
    $[19] = onSetCurrentFolderId;
    $[20] = quickFilterProps;
    $[21] = searchInputProps;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  const value = t3;
  let t4;
  if ($[23] !== filterGroups || $[24] !== quickFilters) {
    t4 = {
      filterGroups,
      quickFilters
    };
    $[23] = filterGroups;
    $[24] = quickFilters;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  const computedFilterValue = t4;
  let t5;
  if ($[26] !== children) {
    t5 = /*#__PURE__*/_jsx(ExpandableObjectIdsContext, {
      initializeStore: _temp,
      children: children
    });
    $[26] = children;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== computedFilterValue || $[29] !== t5) {
    t6 = /*#__PURE__*/_jsx(FilterContext.Provider, {
      value: computedFilterValue,
      children: t5
    });
    $[28] = computedFilterValue;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== filtersStateStore || $[32] !== t6) {
    t7 = /*#__PURE__*/_jsx(FilterStateStoreContext, {
      store: filtersStateStore,
      children: t6
    });
    $[31] = filtersStateStore;
    $[32] = t6;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== t7 || $[35] !== value) {
    t8 = /*#__PURE__*/_jsx(CrmObjectTypeListingContext.Provider, {
      value: value,
      children: t7
    });
    $[34] = t7;
    $[35] = value;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  return t8;
}
function _temp() {
  return createExpandableObjectIdsStore();
}
export function useCrmObjectType() {
  "use memo";

  const context = useContext(CrmObjectTypeListingContext);
  if (context === null) {
    throw new Error("useCrmObjectType must be used within a CrmObjectTypeListingClientProvider");
  }
  return context;
}
export function useComputedFilters() {
  "use memo";

  const context = useContext(FilterContext);
  if (context === null) {
    throw new Error("useComputedFilters must be used within a CrmObjectTypeListingClientProvider");
  }
  return context;
}
export { useExpandableObjectIdsStore, useFiltersStateStore };